export const legacyIssueRoute = {
	name: 'legacy-issue',
	path: '/browse/:issueKey(\\w+-\\d+)(.*)',
	query: ['jql!=(.+)', 'filter!=(.+)'],
};
